import { GdprConsentProvider } from '~/jobiqo/components/GDPRConsent/hooks/useGdprConsentContext';
import JobAlertProvider from '~/jobiqo/components/JobAlert/context';
import { JobSearchSplit } from '~/jobiqo/components/JobSearch/SplitView';
import {
  getMiniSiteJobsPath,
  getMiniSiteOrganizationConditionGroup,
} from '~/jobiqo/components/Organization/MiniSite/utils';
import { PAGE_TYPES } from '~/jobiqo/lib/analytics';
import JobSearchProvider from '~/jobiqo/context/jobSearch';
import styles from '../miniSite.module.scss';
import { OrganizationMiniSiteLayout } from './OrganizationMiniSiteLayout';
import { OrganizationMiniSiteTabs } from './OrganizationMiniSiteTabs';
import type { OrganizationMiniSiteJobsPageProps } from './types';
import { getMiniSiteMenuItems, getMiniSiteRootPath } from './utils';

export const OrganizationMiniSiteJobsPage = ({
  organization,
  path,
  querystring,
  jobSearch,
}: OrganizationMiniSiteJobsPageProps) => {
  const miniSiteRootPath = getMiniSiteRootPath(organization);
  const menuItems = getMiniSiteMenuItems(organization);

  return (
    <OrganizationMiniSiteLayout
      organization={organization}
      headerContent={
        <OrganizationMiniSiteTabs
          activeTab="jobs"
          homePath={miniSiteRootPath}
          jobsPath={getMiniSiteJobsPath(miniSiteRootPath)}
          menuItems={menuItems}
        />
      }
    >
      <div
        id="mini_site_panel_jobs"
        className={styles.tabPanel}
        role="tabpanel"
      >
        <GdprConsentProvider>
          {/* Job alerts created from the mini-site should be scoped to this
              organization, so the provider injects an extra search condition. */}
          <JobAlertProvider
            additionalConditionGroups={[
              getMiniSiteOrganizationConditionGroup(organization.id),
            ]}
            forceJobSearchPage={true}
            pageType={PAGE_TYPES.MINISITE}
          >
            {/* The search provider keeps the current query and selected job in
                context for the split-view search UI. */}
            <JobSearchProvider
              initialQuerystring={querystring}
              initialJob={jobSearch.initialJob}
              enabledModules={jobSearch.enabledModules}
            >
              <JobSearchSplit
                querystring={querystring}
                loading={jobSearch.loading}
                error={jobSearch.error}
                data={jobSearch.data}
                // Keep search navigation inside this mini-site route instead
                // of sending users to the global job-search page.
                searchUrl={path}
                jobSearchFacetsConfig={[]}
                fullTextOnly={true}
                renderLayout={false}
                shallowJobSearch={true}
                boxSearchForm={true}
                containerSize="xLarge"
                disableJobDetailCoverOverlap={true}
                hideJobDetailBreadcrumbs={true}
                pageType={PAGE_TYPES.MINISITE}
                analyticsOrganizationName={
                  organization.organization?.name ?? organization.name
                }
              />
            </JobSearchProvider>
          </JobAlertProvider>
        </GdprConsentProvider>
      </div>
    </OrganizationMiniSiteLayout>
  );
};
